//   在http.js中引入axios
import FinD from '@weus/fuc-design';
import axios from 'axios'; //引入 axios
import qs from 'qs';
import moment from 'moment';

const { Message } = FinD;
function getUrlParams(name) {
  // 不传name返回所有值，否则返回对应值
  let url = window.location.search;
  if (url.indexOf('?') === 1) {
    return false;
  }
  url = url.substr(1);
  url = url.split('&');
  name = name || '';
  let nameres;
  // 获取全部参数及其值
  for (let i = 0; i < url.length; i++) {
    const info = url[i].split('=');
    const obj = {};
    obj[info[0]] = decodeURI(info[1]);
    url[i] = obj;
  }
  // 如果传入一个参数名称，就匹配其值
  if (name) {
    for (let i = 0; i < url.length; i++) {
      for (const key in url[i]) {
        if (key === name) {
          nameres = url[i][key];
        }
      }
    }
  } else {
    nameres = url;
  }
  // 返回结果
  return nameres;
}

function getParams() {
  const names = getUrlParams();
  let params = {};
  names.forEach(it => {
    params = {
      ...params,
      ...it
    };
  });
  return params;
}

// create an axios instance   创建axios实例
const service = axios.create({
  responseType: 'json',
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    'X-Requested-With': 'XMLHttpRequest'
  },
  transformRequest: [function (data) {
    if (Object.prototype.toString.call(data) == '[object FormData]') {
      // 不是formdata类型
      data = data
    } else if (data !== null && typeof data === 'object') {
      Date.prototype.toJSON = function () {
        return moment(this).format('YYYY-MM-DDTHH:mm:ss');
      }

      data = JSON.stringify(data)
    }

    return data
  }]
});

service.interceptors.request.use(config => {
  if (config.method === 'get') {
    const params = getParams();
    if (Object.keys(params).length) {
      config.params = {
        ...getParams(),
        ...config.params
      };
      for (var key in config.params) {
        if (config.params[key] == 'undefined') {
          delete config.params[key];
        }
      }
    }

    config.paramsSerializer = function (params) {
      return qs.stringify(params,
        {
          arrayFormat: 'repeat',
          serializeDate: (date) => {
            //用moment处理日期比较方便，自己写格式化方法也可以
            return moment(date).format('YYYY-MM-DDTHH:mm:ss')
          },
          encode: false
        })
    }
  }
  return config;
});

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response.config.flag ? response : response.data);
    } else {
      return Promise.reject(response);
    }
  },
  err => {
    if (err.response) {

      if(err.response.status === 511) {
        setTimeout(() => {
          localStorage.removeItem('authToken')
          if(location.pathname !== '/login') {
            location.href = '/login'
          }
        }, 1000)
        return
      }
      
      let errorInfo = ''
      try{
        errorInfo = decodeURIComponent(err.response.headers['www-authenticate'] || '')
        if(errorInfo) {
          Message({
            message: errorInfo,
            type: 'error',
            customClass: 'Zzindex'
          });
        }
      }catch(e) {
        errorInfo = ''
      }

      if (err.response.status === 401) {
        setTimeout(() => {
          localStorage.removeItem('authToken')
          if(location.pathname !== '/login') {
            location.href = '/login'
          }
        }, 1000)
      }

      if (err.response.status === 403) {
        Message({
          message: '接口权限不足，请咨询平台客服！',
          type: 'error',
          customClass: 'Zzindex'
        });
      } 

      if (err.response.status >= 500) {
        Message({
          message: err.response.data.message,
          type: 'error',
          customClass: 'Zzindex'
        });
      }
    }
    return Promise.reject(err);
  }
);

service.request = data => {
  if (data.proxyName) {
    data.url =
      process.env.NODE_ENV === 'development' ? `/${data.proxyName}${data.url}` : `${location.origin}/api/${data.proxyName}${data.url}`;
  }

  data['headers'] = Object.assign({}, data.headers)
  let authToken = localStorage.getItem('authToken')
  if (authToken) {
    data['headers']["Authorization"] = `Bearer ${authToken}`;
  }else {
    if(!data.url.includes('captcha') && !data.url.includes('/token/create') && !data.url.includes('/token/logout')) {
      if(location.pathname !== '/login') {
        location.href = '/login'
      }
      return
    }
  }
  
  return service(data);
};

export default service;
